/**
 * @generated SignedSource<<921b0d77d2559e64a091b8eecacb6519>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type MondayImportExistingTicketPaneTicketQuery$variables = {
  itemId: string;
};
export type MondayImportExistingTicketPaneTicketQuery$data = {
  readonly viewer: {
    readonly integrations: {
      readonly monday: {
        readonly item: {
          readonly boardId: string;
          readonly boardName: string;
          readonly externalId: string;
          readonly groupName: string;
          readonly id: string;
          readonly name: string;
        } | null;
      } | null;
    };
  };
};
export type MondayImportExistingTicketPaneTicketQuery = {
  response: MondayImportExistingTicketPaneTicketQuery$data;
  variables: MondayImportExistingTicketPaneTicketQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "itemId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "itemId",
      "variableName": "itemId"
    }
  ],
  "concreteType": "MondayItemNode",
  "kind": "LinkedField",
  "name": "item",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "boardId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "boardName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "groupName",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MondayImportExistingTicketPaneTicketQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MondayUserNode",
                "kind": "LinkedField",
                "name": "monday",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MondayImportExistingTicketPaneTicketQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MondayUserNode",
                "kind": "LinkedField",
                "name": "monday",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a5f2fb5ab1e5e4b267ec555ad05b6385",
    "id": null,
    "metadata": {},
    "name": "MondayImportExistingTicketPaneTicketQuery",
    "operationKind": "query",
    "text": "query MondayImportExistingTicketPaneTicketQuery(\n  $itemId: String!\n) {\n  viewer {\n    integrations {\n      monday {\n        item(itemId: $itemId) {\n          id\n          name\n          externalId\n          boardId\n          boardName\n          groupName\n        }\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "9a588b93519a73d47aea569eb74034da";

export default node;
